
import { FieldControl } from '@signature-it/ngx-generic/enums';
import { FormField } from './field';

export class CardValidity extends FormField {

    static MONTH_FIELD = 'month';
    static YEAR_FIELD = 'year';

    controlType = FieldControl.CARD_VALIDITY;
    monthOptions : Array<number>;
    yearOptions : Array<number>;

    constructor(attributes?: Object) {
        super(attributes);
        this.setMonth();
        this.setYears();
    }

    setMonth() {
        this.monthOptions = Array(12).fill(1).map((x, i) => i + 1);
    }

    setYears() {
        const yearsFrom = (new Date()).getFullYear();
        const yearsTo = (new Date()).getFullYear() + 9;
        this.yearOptions = Array(yearsTo - yearsFrom + 1).fill(1).map((x, i) => i+yearsFrom );
    }

}
